//-------------------------------------------------------------------------------------------------- Imports
import { Card, Col, Row, Skeleton, Typography } from "antd";
import { StyleSheet } from "../../StyleSheet";
import SubDefaultLayout from "../../components/SubDefaultLayout";
import { useCallback, useEffect, useState } from "react";
import { ResponseDiscountsData } from "../../types/common";
import _ from "lodash";
import { referredReportDiscounts } from "../../methods/Methods";
import { useSelector } from "react-redux";
import { getGeneralData } from "../../stores/slices/generalDataSlice";
import { useNavigate } from "react-router-dom";

const { Text } = Typography;

//-------------------------------------------------------------------------------------------------- View
const ReportDiscounts = () => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [listDiscountApplied, setListDiscountApplied] = useState<Array<ResponseDiscountsData>>([]);
    const generalData = useSelector(getGeneralData);
    const [clientId, setClientId] = useState<string>("");
    const [message, setMessage] = useState("");
    const [hasError, setHasError] = useState(false);
    const navigate = useNavigate();

    const getData = useCallback(async () => {
        setIsLoading(true);
        await referredReportDiscounts(clientId)
            .then((response) => {
                if (response.data && response.data.data && response.data.data[0].data && response.data.data[0].data.length > 0) {
                    setListDiscountApplied(response.data.data[0].data);
                } else {
                    setMessage("No cuenta con descuentos aplicados.");
                }
                setIsLoading(false);
            })
            .catch(() => {
                setHasError(true);
                setMessage("Hubo un error al procesar su solicitud. \nIntente más tarde.");
                setIsLoading(false);
            })
    }, [clientId]);

    useEffect(() => {
        if (generalData.selectedContract !== null) {
            setClientId(
                generalData.selectedContract.sucursal + generalData.selectedContract.suscriptor
            );
        }
    }, [generalData.selectedContract]);

    useEffect(() => {
        if (clientId && !_.isEmpty(clientId)) {
            getData();
        }
    }, [clientId, getData]);

    return (
        <>
            <SubDefaultLayout
                title={"Reporte de descuentos"}
                needReturn={true}
                navigateTo="/referral-system"
            >
                <Row justify={"center"}>
                    <Col xs={24} lg={12}>
                        <Card style={styles.card}>
                            <Row style={styles.cardInterior}>
                                <Text style={styles.textTitle}>
                                    ¡Estimado Usuario!
                                </Text>
                                <Text style={styles.textContent}>
                                    En este apartado podrás revisar los descuentos que han sido aplicados a tu contrato de acuerdo a los términos y condiciones.
                                </Text>
                                <Text style={styles.textContent}>
                                    Puede consultarlos en:
                                </Text>
                                <Col xs={24}>
                                    <Text
                                        style={styles.textLink}
                                        onClick={() => navigate("/terms-and-conditions")}
                                    >
                                        Términos y condiciones
                                    </Text>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
                <br />
                {
                    isLoading ?
                        <Card style={styles.card}>
                            <Skeleton style={styles.container} />
                        </Card>
                        :
                        !_.isEmpty(listDiscountApplied) && !hasError ?
                            <Card style={styles.card}>
                                <table style={styles.table}>
                                    <thead>
                                        <tr>
                                            <th style={{ ...styles.titleTable, borderTopLeftRadius: 25, borderBottomLeftRadius: 25 }}>
                                                {"Suscriptor"}
                                            </th>
                                            <th style={styles.titleTable}>
                                                {"Código"}
                                            </th>
                                            <th style={styles.titleTable}>
                                                {"Canjeado"}
                                            </th>
                                            <th style={styles.titleTable}>
                                                {"Referido"}
                                            </th>
                                            <th style={{ ...styles.titleTable, borderTopRightRadius: 25, borderBottomRightRadius: 25 }}>
                                                {"Descuentos"}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            listDiscountApplied.map((element: any, index: any) => (
                                                <tr key={index} style={styles.tableDataRow}>
                                                    <td style={styles.textContainOthers}>
                                                        {element.suscriptor}
                                                    </td>
                                                    <td style={styles.textContainOthers}>
                                                        {element.codigo}
                                                    </td>
                                                    <td style={styles.textContainOthers}>
                                                        {element.fecha_canje}
                                                    </td>
                                                    <td style={styles.textContainOthers}>
                                                        {element.referido}
                                                    </td>
                                                    <td style={styles.textContainOthers}>
                                                        {element.descuento}
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </Card>
                            :
                            <div style={styles.divNoCalls}>
                                <Text style={styles.noCalls}>
                                    {message}
                                </Text>
                            </div>
                }

            </SubDefaultLayout>
        </>
    );
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    card: {
        borderRadius: 20,
        boxShadow: "0px 0px 8px #00000029",
        marginTop: 20
    },
    container: {
        width: "100%",
    },
    table: {
        width: "100%",
        borderCollapse: "collapse",
        borderSpacing: 0,
        overflow: 'hidden',
    },
    titleTable: {
        backgroundColor: "#0055c2",
        fontSize: 13,
        color: 'white',
        textAlign: "center",
        padding: "5px 10px",
    },
    tableDataRow: {
        borderBottom: "1px solid #000000",
    },
    divNoCalls: {
        justifyContent: 'center',
        display: 'flex',
    },
    noCalls: {
        fontSize: 18,
        fontWeight: 600,
        marginTop: 15,
        color: "#085bc2",
    },
    textContainOthers: {
        fontSize: 12,
        color: "#646567",
        textAlign: "center",
        paddingTop: 20,
        paddingBottom: 20
    },
    cardInterior: {
        justifyContent: "center",
        textAlign: "center"
    },
    textTitle: {
        color: "#000000",
        fontWeight: 600,
        fontSize: 16
    },
    textContent: {
        marginTop: 10
    },
    textLink: {
        marginTop: 10,
        cursor: "pointer",
        textDecoration: "underline",
        color: "#287dd2"
    },
});

//-------------------------------------------------------------------------------------------------- Exports
export default ReportDiscounts;
